<template>
  <v-app id="app">
    <main-menu v-model="navigationDrawer" v-if="!isLoginMode"></main-menu>

    <v-app-bar
      v-if="!isLoginMode"
      app
      color="primary"
      dark
    >
      <v-app-bar-nav-icon style="background: transparent;" @click="navigationDrawer = !navigationDrawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $store.state.customer ? $store.state.customer.site.name : '' }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn icon @click="logout" style="background: transparent;">
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>
      
    </v-app-bar>

    <v-main v-if="isLoginMode">
        <router-view/>
    </v-main>
    <v-main v-else>
      <v-container class="grey lighten-5 fill-height align-start pa-0">
        <router-view/>
      </v-container>

      <v-snackbar
        v-model="showSnackbar"
        :timeout="2000"
      >
        {{ messages[messages.length - 1] }}

        <template v-slot:action="{ attrs }">
          <v-btn
            icon
            @click="showSnackbar = false"
            v-bind="attrs"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

    </v-main>
  </v-app>
</template>

<script>
export default {  
  data() {
    return {
      navigationDrawer: false,
      showSnackbar: false
    }
  },

  created() {
    this.$store.dispatch('loadCustomerInfo');
  },

  mounted() {
    
  },

  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    }
  },

  computed: {
    isLoginMode() {
      return this.$route.name == 'Login';
    },
    messages() {
      return this.$store.state.globalMessages;
    }
  },

  watch: {
    showSnackbar: function(newVal, oldVal) {
      if (!newVal) {
       this.$store.commit('POP_MESSAGE');
       if (this.messages.length > 0) {
         this.$nextTick(() => { this.showSnackbar = true })
       }
      }
    },
    messages: function(newVal, oldVal) {
      if (newVal.length > 0 && !this.showSnackbar) this.showSnackbar = true;
    }
  },
}
</script>